export default __webpack_public_path__ + "static/media/crashSchool.83ed7b20.svg";